import { ApiResponse } from '@/shared';
import { NotificationModel } from '../domain';

export abstract class NotificationRepository {
  abstract getUnseenNotifications(): Promise<NotificationModel[]>;
  abstract dismissAllNotifications(): Promise<ApiResponse<unknown>>;
  abstract dismissNotification(
    notificationId: number,
  ): Promise<ApiResponse<unknown>>;
}
